// store/tourStore.ts

import { create } from 'zustand';
import { TourProps, tourDefaultProps } from '../designSystem/components/tours';

/**
 * Extend the TourProps interface to add actions for updating any part of the store.
 */
interface TourState {
  /**
   * A single action that can update one or more TourProps fields at once.
   */
  tourProps: Partial<TourProps>;
  setTourProps: (updatedProps: Partial<TourProps>) => void;
}

/**
 * Initialize the Zustand store with default values for ALL TourProps fields.
 */

export const useTourStore = create<TourState>()((set) => ({
  /**
   * -----------
   * TourProps
   * -----------
   */

  tourProps: tourDefaultProps,

  /**
   * -----------
   * Actions
   * -----------
   */

  /**
   * Update one or more TourProps fields at once.
   */
  setTourProps: (updatedProps) =>
    set((state) => ({
      tourProps: {
        ...state.tourProps,
        ...updatedProps,
      },
    })),
}));
